import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AcsCodesLookupQueryEntity, AppMetaData, AppMetaDataLookups, PlanOfActionEntity, PlanOfActionQuestionResultEntity, PlanOfActionSectionQuestionEntity } from '../../../../meta-data/app-meta-data.service';
import { AcsCodesStorageItem, AcsCodeStatuses } from '../../models/acs-code-items.model';
import { PlanOfActionUtilService } from '../../services/plan-of-action-util.service';

@Component({
  selector: 'app-plan-of-action-execute-question',
  templateUrl: './plan-of-action-execute-question.component.html',
  styleUrls: ['./plan-of-action-execute-question.component.scss']
})
export class PlanOfActionExecuteQuestionComponent implements OnInit, OnChanges {
  @Input() question: PlanOfActionSectionQuestionEntity;
  @Input() result: PlanOfActionQuestionResultEntity;
  @Output() resultChange = new EventEmitter<PlanOfActionQuestionResultEntity>();

  @Input() planOfAction: PlanOfActionEntity;
  @Input() acsCodes: AcsCodesStorageItem;
  @Input() showAcsCode: boolean;
  @Input() acsCodeStatuses: AcsCodeStatuses;
  @Input() readOnly: boolean = false;

  acsCode: AcsCodesLookupQueryEntity;
  showQuestion: boolean;
  showNotes: boolean;

  isMissedCode: boolean = false;

  questionClass : string;
  missingAcsCodeImageUrl: string;
  constructor(private planofActionUtilService: PlanOfActionUtilService) {
    this.missingAcsCodeImageUrl = this.planofActionUtilService.getMissedAcsCodeImageUrl();


   }

  outcomeLookupId = AppMetaDataLookups.QuestionOutcomeAllItems;

  ngOnInit(): void {
    this.setupQuestion();
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    this.setupQuestion();
  }

  clearOutcome(result: PlanOfActionQuestionResultEntity) {
    if (this.readOnly) {
      return;
    }

    result.QuestionOutcomeId = null;

    this.onChange();
  }

  checkedValue: boolean = false;

  updateCheckedValue() {
    if (this.readOnly) {
      return;
    }

    if (this.checkedValue) {
      this.result.QuestionOutcomeId = 1;
    } else {
      this.result.QuestionOutcomeId = null;
    }

    this.onChange();
  }

  setupQuestion() {
    if (this.result == null) {
      this.result = AppMetaData.PlanOfActionQuestionResult.CreateEntity();
      this.result.PlanOfActionSectionQuestionId = this.question?.PlanOfActionSectionQuestionId;
    }

    if (this.acsCodes && this.question?.AcsCodeId && this.question.AcsCodeId != this.acsCode?.AcsCodeId) {
      this.acsCode = this.acsCodes.codesById[this.question.AcsCodeId];

      this.isMissedCode = !!this.acsCodeStatuses?.codesById[this.question.AcsCodeId];
    }

    this.showQuestion = !this.showAcsCode || (this.planOfAction.OptionsShowQuestionForAcsCode && !!this.question?.QuestionHtml);

    this.showNotes = this.showAcsCode || this.question.ShowNotes;

    if (this.result.QuestionOutcomeId) {
      this.checkedValue = true;
    }

    this.questionClass = this.showAcsCode ? '' : 'basic-question';
  }

  onChange() {
    if (this.readOnly) {
      return;
    }

    this.resultChange.emit(this.result);
  }

  getOutcomeDisplay(): string {
    return this.result?.QuestionOutcomeIdDisplay || this.result?.QuestionOutcome?.QuestionOutcome || '';
  }

  get showReadOnlyNotes(): boolean {
    return this.readOnly && !!this.result?.Notes;
  }

  get showQuestionDescription(): boolean {
    return !this.showQuestion || !!this.acsCode?.AscCodeDescription;
  }

} 
 
